import { useEffect, useState } from "react";
import FrothAiIcon from "../common/FrothAiIcon";

const NAME = ["F", "r", "o", "t", "h", "A", "I"];
// Matches the end of the fade-out in FrothAI.css (.fai-intro).
const DURATION_MS = 3000;

// Landing intro for /froth-ai: the tile drops from the top to the centre, the
// icon draws itself, a cursor types the name, then the glass melts into the page.
// Skipped for visitors who prefer reduced motion; a click dismisses it early.
export default function FrothAiIntro() {
  const [show, setShow] = useState(
    () => typeof window !== "undefined" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  const [playing, setPlaying] = useState(false);

  // Start once the overlay has painted, so a busy first load can't swallow the drop.
  useEffect(() => {
    if (!show) return undefined;
    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => setPlaying(true));
    });
    return () => cancelAnimationFrame(frame);
  }, [show]);

  useEffect(() => {
    if (!playing) return undefined;
    const timer = setTimeout(() => setShow(false), DURATION_MS);
    return () => clearTimeout(timer);
  }, [playing]);

  if (!show) return null;

  return (
    <div className={`fai-intro${playing ? " is-playing" : ""}`} aria-hidden="true" onClick={() => setShow(false)}>
      <div className="fai-intro__stage">
        <span className="fai-intro__tile">
          <span className="fai-intro__face" />
          <FrothAiIcon size={52} />
          <span className="fai-intro__scan" />
        </span>
        <span className="fai-intro__name">
          {NAME.map((letter, i) => (
            <span key={i} className={i >= 5 ? "is-ai" : undefined} style={{ "--i": i }}>
              {letter}
            </span>
          ))}
          <span className="fai-intro__caret" />
        </span>
        <span className="fai-intro__tag">AI built into Froth TestOps</span>
      </div>
    </div>
  );
}
